module.exports = __webpack_public_path__ + "img/rsource_msourcetoken.0f77ed0.png";